"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _has = _interopRequireDefault(require("lodash/has"));
var _find = _interopRequireDefault(require("lodash/find"));
var _map = _interopRequireDefault(require("lodash/map"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _difference = _interopRequireDefault(require("lodash/difference"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _AbstractConfiguratorService = _interopRequireDefault(require("../../Framework/Services/AbstractConfiguratorService"));
var _Actions = _interopRequireWildcard(require("../Reducers/Configurator/Actions"));
var configuratorActions = _Actions;
var _Selectors = require("../Reducers/Configurator/Selectors");
var _Selectors2 = require("../Reducers/DesignArea/Selectors");
var _Actions2 = require("../Reducers/UI/Actions");
var _Selectors3 = require("../Reducers/Fonts/Selectors");
var _ServiceLocator = require("../ServiceLocator");
var _configuration2 = require("../configuration");
var _Reducer = require("../Reducers/DesignData/Reducer");
var _cached = require("../../Utils/Function/cached");
var _getFirstDataURLFromScreenshotsObj = require("../Modules/Visualization/Utils/getFirstDataURLFromScreenshotsObj");
var _Selectors4 = require("../Reducers/DesignData/Selectors");
var _createMessageInterface = _interopRequireWildcard(require("../Utils/createMessageInterface"));
var _SvgFixers = require("../Modules/Designer/Utils/SvgFixers");
var _excluded = ["code"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var getSelectedAmountsBySizes = function getSelectedAmountsBySizes(item, selectedAmounts) {
  var itemGroupMap = function itemGroupMap(rootItem, fn) {
    var data = [];
    if ((0, _get["default"])(rootItem, 'itemGroup.children.length', 0) > 0) {
      var _iterator = _createForOfIteratorHelper(rootItem.itemGroup.children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _item = _step.value;
          var mappedData = fn(_item, data);
          mappedData && data.push(mappedData);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return data;
  };
  return itemGroupMap(item, function (colorGroupItem) {
    return {
      identifier: colorGroupItem.identifier,
      amount: (0, _get["default"])(selectedAmounts, colorGroupItem.identifier, 0),
      sizes: itemGroupMap(colorGroupItem, function (sizeGroupItem) {
        return {
          amount: (0, _get["default"])(selectedAmounts, sizeGroupItem.identifier, 0),
          identifier: sizeGroupItem.identifier
        };
      })
    };
  });
};
var ConfiguratorService = exports["default"] = /*#__PURE__*/function (_AbstractConfigurator) {
  _inherits(ConfiguratorService, _AbstractConfigurator);
  var _super = _createSuper(ConfiguratorService);
  function ConfiguratorService() {
    var _this;
    _classCallCheck(this, ConfiguratorService);
    _this = _super.call(this);
    _ServiceLocator.Services.store.observeStore(function (state) {
      return state.configurator.configuration;
    }, function () {
      // since it's debounced, the prevConfiguration should be the configuration from the latest call
      var prevConfiguration = {};
      return (0, _debounce["default"])(function (configuration) {
        _this.onConfigurationChange(configuration, prevConfiguration);
        prevConfiguration = configuration;
      }, 300);
    }());
    return _this;
  }
  _createClass(ConfiguratorService, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var adminMode = (0, _configuration2.getConf)('adminMode');
      if (!adminMode) {
        var messageInterface = (0, _createMessageInterface["default"])();
        messageInterface.addListener(_createMessageInterface.LISTENER_SWITCH_OPTIONS, /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
            var optionsJSON, optionsToSelect;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  optionsJSON = (0, _get["default"])(event, 'data.options');
                  try {
                    optionsToSelect = JSON.parse(optionsJSON);
                    _ServiceLocator.Services.store.dispatch((0, _Actions.selectMultipleOptions)(optionsToSelect));
                  } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Wrong JSON provided for switch_options:', optionsJSON);
                  }
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        messageInterface.addListener(_createMessageInterface.LISTENER_SAVE_CONFIGURATION, /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
            var save_id, saveType, configuration, code;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  save_id = (0, _get["default"])(event, 'data.save_id');
                  saveType = (0, _get["default"])(event, 'data.save_type') === _configuration2.SaveTypes.CART ? _configuration2.SaveTypes.CART : _configuration2.SaveTypes.USER;
                  _context2.prev = 2;
                  _context2.next = 5;
                  return _this2.captureAndSaveConfiguration(saveType);
                case 5:
                  configuration = _context2.sent;
                  code = (0, _get["default"])(configuration, 'data.code');
                  messageInterface.dispatch({
                    method: _createMessageInterface.METHOD_CONFIGURATION_SAVED_REMOTELY,
                    save_id: save_id,
                    code: code
                  });
                  _context2.next = 13;
                  break;
                case 10:
                  _context2.prev = 10;
                  _context2.t0 = _context2["catch"](2);
                  // eslint-disable-next-line no-console
                  console.error('Saving configuration failed, save_id was  ', save_id);
                case 13:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, null, [[2, 10]]);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    }

    // state selector
  }, {
    key: "state",
    get: function get() {
      return _ServiceLocator.Services.store.state.configurator;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var params = {};
      var basePath = (0, _configuration2.getConf)('routingBasePath', '/');
      var itemRegex = new RegExp("".concat(basePath, "(code|identifier):([^/]+)"));
      var results = itemRegex.exec(location.pathname);
      if (results) {
        params[results[1]] = results[2];
      }
      if (params.identifier) {
        this.setLoadIdentifier(params.identifier);
      } else if (params.code) {
        this.setLoadCode(params.code);
      }
      this.loadClientData();
    }
  }, {
    key: "prepareConfigurationForSave",
    value: function prepareConfigurationForSave() {
      var overwrite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var extraData = arguments.length > 1 ? arguments[1] : undefined;
      var configuration = this.state.configuration;
      var updatedConfiguration = _ServiceLocator.Services.designData.removeAllDesignAreaPlaceholders(configuration);

      // remove the code by default (to prevent overwriting the current configuration)
      var code = updatedConfiguration.code,
        otherData = _objectWithoutProperties(updatedConfiguration, _excluded);

      // always remove parentCode from customdata
      var customdata = (0, _omit["default"])(updatedConfiguration.customdata || {}, ['parentCode']);

      // add parentCode only when it's set in the config
      if ((0, _configuration2.getConf)('addParentCodeOnSave')) {
        customdata.parentCode = code;
      }
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, otherData), overwrite ? {
        code: code
      } : {}), extraData), {}, {
        customdata: customdata
      });
    }
  }, {
    key: "setCalculationAutoResolveEnabled",
    value: function setCalculationAutoResolveEnabled(enabled) {
      _ServiceLocator.Services.store.dispatch((0, _Actions.setCalculationAutoResolveEnabled)(enabled));
    }
  }, {
    key: "skipNextCalculationAutoResolve",
    value: function skipNextCalculationAutoResolve() {
      _ServiceLocator.Services.store.dispatch((0, _Actions.skipNextAutoResolve)());
    }
  }, {
    key: "onConfigurationChange",
    value: function () {
      var _onConfigurationChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(configuration, prevConfiguration) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.state.calculationIsEnabled && (!configuration.check_results ||
              // no check results
              configuration.check_results.status) &&
              // or the check result status is ok
              this.shouldInvalidateCalculation(prevConfiguration, configuration))) {
                _context3.next = 11;
                break;
              }
              if (!(0, _Selectors.isCalculationAutoResolveEnabled)(this.state)) {
                _context3.next = 9;
                break;
              }
              // disable automatic price updates to take direct control over error handling
              _ServiceLocator.Services.store.dispatch((0, _Actions.setCalculationEnabled)(false));
              // triggering the calculation directly to make sure it's synced
              _context3.next = 5;
              return _ServiceLocator.Services.store.dispatch(configuratorActions.doCalculation());
            case 5:
              _ServiceLocator.Services.store.dispatch((0, _Actions.setCalculationEnabled)(true));
              _ServiceLocator.Services.configurator.resolveCalculationErrors();
              _context3.next = 11;
              break;
            case 9:
              _ServiceLocator.Services.store.dispatch(configuratorActions.invalidateCalculation());
              _ServiceLocator.Services.store.dispatch(configuratorActions.doCalculation());
            case 11:
              if (this.shouldUpdateVisualization(prevConfiguration, configuration)) {
                _ServiceLocator.Services.visualization.update(configuration);
              }
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function onConfigurationChange(_x3, _x4) {
        return _onConfigurationChange.apply(this, arguments);
      }
      return onConfigurationChange;
    }()
  }, {
    key: "shouldInvalidateCalculation",
    value: function shouldInvalidateCalculation(prevConfiguration, configuration) {
      return this.isRoughEqual(configuration, prevConfiguration);
    }
  }, {
    key: "shouldUpdateVisualization",
    value: function shouldUpdateVisualization(prevConfiguration, configuration) {
      return this.isRoughEqual(configuration, prevConfiguration);
    }
  }, {
    key: "isRoughEqual",
    value: function isRoughEqual(configuration, prevConfiguration) {
      // calculation should be invalidated only when one of the relevant properties has changed
      var pc = this.getRoughConfiguration(prevConfiguration);
      var cc = this.getRoughConfiguration(configuration);
      return !(0, _isEqual["default"])(cc, pc);
    }

    /**
     * Returns the configuration core values
     * Use this method to create a more simple comparable object that represents the same
     * configuration
     * @param configuration
     * @returns {{item: {identifier: *, price: *}, optionclassifications: Array, designdata: {}, customdata: {}}}
     */
  }, {
    key: "getRoughConfiguration",
    value: function getRoughConfiguration(configuration) {
      var item = configuration.item,
        optionclassifications = configuration.optionclassifications,
        designdata = configuration.designdata;
      var customdata = configuration.customdata && (0, _omit["default"])(configuration.customdata, ['comment']);
      return {
        item: item && {
          identifier: item.identifier,
          price: item.price
        },
        optionclassifications: optionclassifications && (0, _map["default"])(optionclassifications, function (oc) {
          return {
            identifier: oc.identifier,
            selectedoptions: (0, _map["default"])(oc.selectedoptions, function (o) {
              return {
                identifier: o.identifier,
                amount: o.amount,
                price: o.price
              };
            })
          };
        }),
        designdata: designdata && this.getRoughDesignData(designdata),
        customdata: customdata
      };
    }

    /**
     * The design data can also invalidate the calculation if any of the relevant properties have changed.
     * (Eg. an object is added or removed, or a design area related option has changed.)
     * @param designData
     * @returns {null|object}
     */
  }, {
    key: "getRoughDesignData",
    value: function getRoughDesignData(designData) {
      if (!designData) {
        return null;
      }
      var designAreas = Object.keys(designData);
      var roughDesignData = {};
      for (var _i = 0, _designAreas = designAreas; _i < _designAreas.length; _i++) {
        var designAreaIdentifier = _designAreas[_i];
        var designAreaData = designData[designAreaIdentifier];
        var canvasData = designAreaData.canvasData,
          designProductionMethodIdentifier = designAreaData.designProductionMethodIdentifier,
          colorAmount = designAreaData.colorAmount;
        roughDesignData[designAreaIdentifier] = {
          objectCount: (0, _get["default"])(canvasData, 'objects.length'),
          designProductionMethodIdentifier: designProductionMethodIdentifier,
          colorAmount: colorAmount
        };
      }
      return roughDesignData;
    }

    //// <-- ACTIONS -->
  }, {
    key: "saveConfiguration",
    value: function () {
      var _saveConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(configuration, configurationtype) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", _ServiceLocator.Services.store.dispatch(configuratorActions.saveConfiguration(configuration, configurationtype)));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function saveConfiguration(_x5, _x6) {
        return _saveConfiguration.apply(this, arguments);
      }
      return saveConfiguration;
    }()
  }, {
    key: "getPreviewImagesForVariants",
    value: function () {
      var _getPreviewImagesForVariants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var options,
          _options$size,
          size,
          designData,
          configurationOptions,
          cached,
          memo,
          designAreas,
          defaultDesignAreaIdentifier,
          areasWithDesign,
          screenshotAreaIdentifier,
          usedAreas,
          firstDesignViewIdentifier,
          usedViews,
          variants,
          screenshots,
          images,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
              _ServiceLocator.Services.designData.closeDesignAreaEditor();
              _ServiceLocator.Services.designData.clearDesignAreaSelection();
              _options$size = options.size, size = _options$size === void 0 ? {
                width: 100,
                height: 100
              } : _options$size;
              designData = (0, _Reducer.getDesignData)(this.state);
              configurationOptions = (0, _Selectors.getConfiguration)(this.state).optionclassifications;
              cached = (0, _cached.getCached)('variantPreviewImages', designData, configurationOptions);
              if (!cached.validate()) {
                _context5.next = 9;
                break;
              }
              return _context5.abrupt("return", cached.getValue());
            case 9:
              memo = _ServiceLocator.Services.designData.createHighlightMemo(false);
              designAreas = _ServiceLocator.Services.store.state.designArea.filteredDesignAreas; // use the first area as default if it's not defined through the production methods
              defaultDesignAreaIdentifier = (0, _Selectors2.getDefaultDesignAreaIdentifierFromProductionMethod)(_ServiceLocator.Services.store.state) || (designAreas.length ? designAreas[0].identifier : null);
              areasWithDesign = designData && Object.keys(designData).filter(function (designAreaIdentifier) {
                return (0, _get["default"])(designData[designAreaIdentifier], 'canvasData.objects.length');
              }); // use the default design area, or the first that contains a design
              screenshotAreaIdentifier = areasWithDesign && (areasWithDesign.indexOf(defaultDesignAreaIdentifier) !== -1 ? defaultDesignAreaIdentifier : areasWithDesign[0]) || defaultDesignAreaIdentifier;
              usedAreas = screenshotAreaIdentifier ? [screenshotAreaIdentifier] : [];
              firstDesignViewIdentifier = (0, _Selectors2.getCameraViewListForDesignAreaList)(designAreas, usedAreas).pop();
              usedViews = [firstDesignViewIdentifier];
              variants = (0, _Selectors.getChildren)(this.state).map(function (_ref3) {
                var identifier = _ref3.identifier;
                return identifier;
              });
              if (!variants[0]) {
                variants = [(0, _Selectors.getItem)(this.state).identifier];
              }
              _context5.prev = 19;
              _context5.next = 22;
              return _ServiceLocator.Services.visualization.getScreenshots({
                areaList: usedAreas,
                viewList: usedViews,
                variantList: variants,
                size: size
              });
            case 22:
              screenshots = _context5.sent;
              if (screenshots) {
                _context5.next = 25;
                break;
              }
              return _context5.abrupt("return", {});
            case 25:
              images = {};
              Object.keys(screenshots).forEach(function (identifier) {
                images[variants.length === 1 ? variants[0] : identifier] = (0, _getFirstDataURLFromScreenshotsObj.getFirstDataURLFromScreenshotsObj)(screenshots[identifier]);
              });
              cached.setValue(images);
              return _context5.abrupt("return", images);
            case 31:
              _context5.prev = 31;
              _context5.t0 = _context5["catch"](19);
              // eslint-disable-next-line no-console
              console.error('Error occurred while generating preview images:', _context5.t0);
            case 34:
              _context5.prev = 34;
              memo.restore();
              return _context5.finish(34);
            case 37:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[19, 31, 34, 37]]);
      }));
      function getPreviewImagesForVariants() {
        return _getPreviewImagesForVariants.apply(this, arguments);
      }
      return getPreviewImagesForVariants;
    }()
  }, {
    key: "togglePlaceholders",
    value: function togglePlaceholders(show) {
      var _this3 = this;
      var canvases = _ServiceLocator.Services.designData.getDesignAreaCanvases();
      canvases.forEach(function (_ref4) {
        var canvas = _ref4.canvas;
        var _iterator2 = _createForOfIteratorHelper(canvas.objects),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var obj = _step2.value;
            if ((0, _Selectors4.isPlaceholderObject)(obj)) {
              obj.wrappedObject.visible = show;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
      return function () {
        return _this3.togglePlaceholders(true);
      };
    }
  }, {
    key: "createMediaDataForConfiguration",
    value: function () {
      var _createMediaDataForConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(configuration) {
        var mediaData, restorePlaceholderVisibility, memo, fontMapping, svgs, fullSvgs, usedAreas, designArea, filteredDesignAreas, usedViews, item, selectedAmounts, selectedVariants, selectedVariant, designViewList, screenshots, _iterator4, _step4, variant, variantImages, _keys, orderedImages, index, key;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              mediaData = {};
              restorePlaceholderVisibility = this.togglePlaceholders(false);
              memo = _ServiceLocator.Services.designData.createHighlightMemo(false);
              fontMapping = (0, _Selectors3.getFontMapping)(_ServiceLocator.Services.store.state);
              _context6.next = 6;
              return _ServiceLocator.Services.designData.getScreenshotsOfElements(fontMapping);
            case 6:
              svgs = _context6.sent;
              mediaData.designDataSnapshots = (0, _SvgFixers.prepareDesignDataSnapshots)(svgs);
              _context6.next = 10;
              return _ServiceLocator.Services.designData.getScreenshots(fontMapping);
            case 10:
              fullSvgs = _context6.sent;
              mediaData.printDesignData = (0, _SvgFixers.preparePrintDesignData)(fullSvgs);
              usedAreas = Object.keys(fullSvgs);
              designArea = _ServiceLocator.Services.store.state.designArea;
              filteredDesignAreas = designArea.filteredDesignAreas;
              usedViews = (0, _Selectors2.getCameraViewListForDesignAreaList)(filteredDesignAreas, usedAreas);
              item = (0, _Selectors.getItem)(this.state);
              selectedAmounts = (0, _Selectors.getSelectedAmounts)(this.state);
              selectedVariants = getSelectedAmountsBySizes(item, selectedAmounts).filter(function (item) {
                if (item.sizes.length > 0) {
                  var _iterator3 = _createForOfIteratorHelper(item.sizes),
                    _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var size = _step3.value;
                      if (size.amount > 0) {
                        return true;
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                } else {
                  if (item.amount > 0) {
                    return true;
                  }
                }
                return false;
              }).map(function (item) {
                return item.identifier;
              });
              selectedVariant = (0, _Selectors.getSelectedVariantIdentifier)(this.state);
              if (selectedVariants.length === 0) {
                selectedVariants.push(selectedVariant);
              }
              designViewList = (0, _Selectors2.getDesignViewListForDesignAreas)(_ServiceLocator.Services.store.state);
              mediaData.screenshots = {};
              _context6.prev = 23;
              _context6.next = 26;
              return _ServiceLocator.Services.visualization.getScreenshots({
                areaList: usedAreas,
                // used in 2D visualization
                viewList: usedViews,
                // used in 3D visualization
                variantList: selectedVariants,
                designViewList: designViewList // used in 2D visualization
              });
            case 26:
              screenshots = _context6.sent;
              if (screenshots) {
                // make sure the order is kept on the server side
                _iterator4 = _createForOfIteratorHelper(selectedVariants);
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    variant = _step4.value;
                    variantImages = screenshots[variant];
                    if (variantImages) {
                      _keys = Object.keys(variantImages);
                      orderedImages = {};
                      for (index = 0; index < _keys.length; index++) {
                        key = _keys[index];
                        orderedImages[index + key] = variantImages[key];
                      }
                      screenshots[variant] = orderedImages;
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              }
              mediaData.screenshots = screenshots;
              _context6.next = 34;
              break;
            case 31:
              _context6.prev = 31;
              _context6.t0 = _context6["catch"](23);
              // do not save in case of an error while generating screenshots
              // eslint-disable-next-line no-console
              console.error('Error occurred while generating screenshots:', _context6.t0);
            case 34:
              memo.restore();
              if (_typeof(configuration) === 'object') {
                Object.assign(configuration, mediaData);
              }
              restorePlaceholderVisibility();
              return _context6.abrupt("return", mediaData);
            case 38:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[23, 31]]);
      }));
      function createMediaDataForConfiguration(_x7) {
        return _createMediaDataForConfiguration.apply(this, arguments);
      }
      return createMediaDataForConfiguration;
    }()
  }, {
    key: "captureAndSaveConfiguration",
    value: function () {
      var _captureAndSaveConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(saveType) {
        var extraData,
          configuration,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              extraData = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              _context7.prev = 1;
              _context7.next = 4;
              return this.editNameAsync(saveType);
            case 4:
              _context7.next = 10;
              break;
            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7["catch"](1);
              // do not save if the name is not entered / confirmed
              // eslint-disable-next-line no-console
              console.error('Custom name editor not confirmed!');
              return _context7.abrupt("return");
            case 10:
              configuration = this.prepareConfigurationForSave(false, extraData);
              _context7.next = 13;
              return this.createMediaDataForConfiguration(configuration);
            case 13:
              return _context7.abrupt("return", this.saveConfiguration(configuration, saveType));
            case 14:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 6]]);
      }));
      function captureAndSaveConfiguration(_x8) {
        return _captureAndSaveConfiguration.apply(this, arguments);
      }
      return captureAndSaveConfiguration;
    }()
  }, {
    key: "editNameAsync",
    value: function editNameAsync(saveType) {
      if ((0, _configuration2.getConf)('editCustomTitleBeforeSave') && (0, _configuration2.getConf)('customTitleSaveTypes').indexOf(saveType) !== -1) {
        _ServiceLocator.Services.ui.show('customTitleEditor');
        return _ServiceLocator.Services.async.create('customEditorConfirm');
      }
    }
  }, {
    key: "validateConfiguration",
    value: function validateConfiguration() {
      return _ServiceLocator.Services.store.dispatch((0, _Actions2.withGlobalLoader)(configuratorActions.validateConfiguration(this.state.configuration)));
    }
  }, {
    key: "saveAndReloadConfiguration",
    value: function () {
      var _saveAndReloadConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(saveType) {
        var tmpConfiguration, _configuration, _this$state, selectedoptionclassification, configuration, loadIdentifier, itemIdentifier;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.state.configuration.item.identifier) {
                _context8.next = 6;
                break;
              }
              tmpConfiguration = (0, _omit["default"])(this.state.configuration, ['code', 'date_created']);
              _context8.next = 4;
              return this.saveConfiguration(tmpConfiguration, saveType);
            case 4:
              _configuration = this.state.configuration;
              this.setLoadCode(_configuration.code);
            case 6:
              _this$state = this.state, selectedoptionclassification = _this$state.selectedoptionclassification, configuration = _this$state.configuration, loadIdentifier = _this$state.loadIdentifier;
              itemIdentifier = configuration.item.identifier || loadIdentifier; // item identifier is required for the following actions
              if (itemIdentifier) {
                _context8.next = 10;
                break;
              }
              return _context8.abrupt("return");
            case 10:
              // reload inspirations
              if ((0, _configuration2.getConf)('loadInspirations')) {
                this.loadInspirations(itemIdentifier);
              }

              // reload configuration variants
              this.loadConfigurationVariants(itemIdentifier);

              // the optionlist should be reloaded as well if open
              if (configuration.item.identifier && selectedoptionclassification.identifier) {
                this.loadOptions(configuration.item.identifier, selectedoptionclassification.identifier, configuration);
              }
            case 13:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function saveAndReloadConfiguration(_x9) {
        return _saveAndReloadConfiguration.apply(this, arguments);
      }
      return saveAndReloadConfiguration;
    }()
  }, {
    key: "setLoadCode",
    value: function setLoadCode(code) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.setLoadCode(code));
    }
  }, {
    key: "setLoadIdentifier",
    value: function setLoadIdentifier(identifier) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.setLoadIdentifier(identifier));
    }
  }, {
    key: "loadInspirations",
    value: function loadInspirations(itemIdentifier) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.fetchInspirations(itemIdentifier));
    }
  }, {
    key: "loadConfigurationVariants",
    value: function loadConfigurationVariants(itemIdentifier) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.fetchConfigurationVariants(itemIdentifier));
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(itemIdentifier, optionClassificationIdentifier, configuration) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.fetchOptions(itemIdentifier, optionClassificationIdentifier, configuration));
    }
  }, {
    key: "loadInitialOptions",
    value: function loadInitialOptions() {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.loadInitialOptionclassification(this.state.configuration));
    }
  }, {
    key: "loadInitialConfiguration",
    value: function loadInitialConfiguration() {
      return _ServiceLocator.Services.store.dispatch((0, _Actions2.withGlobalLoader)(configuratorActions.fetchInitialConfiguration()));
    }
  }, {
    key: "loadConfigurationForDesignerProductPreview",
    value: function loadConfigurationForDesignerProductPreview() {
      return _ServiceLocator.Services.store.dispatch((0, _Actions2.withGlobalLoader)(configuratorActions.fetchConfigurationForDesignerProductPreview()));
    }
  }, {
    key: "loadCodeSnippets",
    value: function loadCodeSnippets() {
      var _this4 = this;
      return _ServiceLocator.Services.store.dispatch(configuratorActions.fetchCodesnippets()).then(function (codeSnippets) {
        return _this4.attachCodeSnippets(codeSnippets);
      });
    }
  }, {
    key: "loadClientData",
    value: function loadClientData() {
      return _ServiceLocator.Services.store.dispatch((0, _Actions2.withGlobalLoader)(configuratorActions.fetchClientData()));
    }
  }, {
    key: "attachCodeSnippets",
    value: function attachCodeSnippets(codeSnippets) {
      if (codeSnippets.data.length > 0) {
        codeSnippets.data.forEach(function (_ref5) {
          var code = _ref5.code;
          var fragment = document.createRange().createContextualFragment(code);
          while (fragment.children.length > 0) {
            document.head.insertBefore(fragment.children[0], document.head.firstElementChild);
          }
        });
        window.dataLayer && _ServiceLocator.Services.analytics.setDataLayer(window.dataLayer);
      }
    }
  }, {
    key: "setSelectedAmount",
    value: function setSelectedAmount(identifier, amount) {
      var isUpdatedByUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return _ServiceLocator.Services.store.dispatch(configuratorActions.setSelectedAmount(identifier || (0, _Selectors.getSelectedVariantIdentifier)(this.state) || this.state.configuration.item.identifier, amount, isUpdatedByUser));
    }
  }, {
    key: "resolveCalculationErrors",
    value: function resolveCalculationErrors() {
      var configuratorstate = _ServiceLocator.Services.store.state.configurator;
      var configurationItem = (0, _get["default"])(configuratorstate, 'configuration.item', {});
      if ((0, _Selectors.createCalculationErrorChecker)(configuratorstate).isMinOrderAmountError()) {
        var calculation = (0, _Selectors.getCalculation)(configuratorstate);
        calculation.errors.forEach(function (error) {
          var variant = '';
          var amount = 0;
          if (error.itemIdentifier === configurationItem.parentItemIdentifier) {
            var selectedAmounts = (0, _Selectors.getSelectedAmounts)(configuratorstate);
            if ((0, _keys2["default"])(selectedAmounts).length > 1) {
              variant = configuratorstate.selectedVariantIdentifier;
              var selectedVariantAmount = (0, _has["default"])(selectedAmounts, configuratorstate.selectedVariantIdentifier) ? selectedAmounts[configuratorstate.selectedVariantIdentifier] : 0;
              amount = error.minimumAmount - error.selectedAmount + selectedVariantAmount;
            } else {
              variant = configuratorstate.selectedVariantIdentifier;
              amount = error.minimumAmount;
            }
          } else {
            variant = error.itemIdentifier;
            amount = error.minimumAmount;
          }
          _ServiceLocator.Services.store.dispatch(configuratorActions.setSelectedAmount(variant, amount, false));
        });
      }
      _ServiceLocator.Services.store.dispatch(configuratorActions.setCalculationErrorsResolved());
    }
  }, {
    key: "updateSelectedAmount",
    value: function updateSelectedAmount(oldVariant, newVariant) {
      if (!(0, _Selectors.isSelectedAmountsUpdated)(this.state) && !(0, _Selectors.hasMultipleVariantsSelected)(this.state)) {
        if (!oldVariant.children && !newVariant.children && !oldVariant.itemGroup && !newVariant.itemGroup) {
          return _ServiceLocator.Services.store.dispatch(configuratorActions.switchSelectedAmount(oldVariant.identifier, newVariant.identifier));
        }
        var oldIdentifiers = (0, _Selectors.getDeepestChildIdentifiers)(oldVariant);
        var newIdentifiers = (0, _Selectors.getDeepestChildIdentifiers)(newVariant);
        var oldIdentifierKeys = (0, _keys2["default"])(oldIdentifiers);
        var newIdentifierKeys = (0, _keys2["default"])(newIdentifiers);
        var sortedOldIdentifierKeys = oldIdentifierKeys.sort(function (a, b) {
          return a.localeCompare(b, 0, {
            numeric: false
          });
        });
        var sortedNewIdentifierKeys = newIdentifierKeys.sort(function (a, b) {
          return a.localeCompare(b, 0, {
            numeric: false
          });
        });
        var identifierDiffs = (0, _difference["default"])(sortedOldIdentifierKeys, sortedNewIdentifierKeys);
        if (identifierDiffs.length === 0 && (0, _isEqual["default"])(sortedOldIdentifierKeys, sortedNewIdentifierKeys)) {
          for (var key in oldIdentifiers) {
            if (!oldIdentifiers.hasOwnProperty(key)) {
              continue;
            }
            if (newIdentifiers[key]) {
              _ServiceLocator.Services.store.dispatch(configuratorActions.switchSelectedAmount(oldIdentifiers[key], newIdentifiers[key]));
            }
          }
        }
      }
    }
  }, {
    key: "clearBulkNames",
    value: function clearBulkNames() {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.clearBulkNames());
    }
  }, {
    key: "saveBulkNames",
    value: function saveBulkNames(identifier, bulkNamesData) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.saveBulkNames(identifier, bulkNamesData));
    }
  }, {
    key: "switchSelectedAmount",
    value: function switchSelectedAmount(oldIdentifier, newIdentifier) {
      this.setSelectedVariantIdentifier(newIdentifier);
      var item = this.state.configuration.item;
      var oldVariant = (0, _find["default"])(item.itemGroup.children, function (o) {
        return o.identifier === oldIdentifier;
      });
      var newVariant = (0, _find["default"])(item.itemGroup.children, function (o) {
        return o.identifier === newIdentifier;
      });
      var selectedAmounts = (0, _Selectors.getSelectedAmounts)(this.state);
      var firstSelectedAmountIdentifier = (0, _keys2["default"])(selectedAmounts)[0];
      var oldSelectedAmountVariant = (0, _find["default"])(item.itemGroup.children, function (o) {
        if (o.itemGroup) {
          var children = o.itemGroup.children;
          return children.find(function (child) {
            return child.identifier === firstSelectedAmountIdentifier;
          });
        } else {
          return o.identifier === firstSelectedAmountIdentifier;
        }
      });
      if (!(0, _configuration2.getConf)('restrictAmountselectionToSelectedVariant', false)) {
        // Updates selected Amounts from previous selectedVariant amount to new variant
        this.updateSelectedAmount(oldSelectedAmountVariant, newVariant);
        return;
      }
      if (!oldVariant.children && !newVariant.children) {
        return _ServiceLocator.Services.store.dispatch(configuratorActions.switchSelectedAmount(oldVariant.identifier, newVariant.identifier));
      }
      var oldIdentifiers = (0, _Selectors.getDeepestChildIdentifiers)(oldVariant);
      var newIdentifiers = (0, _Selectors.getDeepestChildIdentifiers)(newVariant);
      for (var key in oldIdentifiers) {
        if (!oldIdentifiers.hasOwnProperty(key)) {
          continue;
        }
        if (newIdentifiers[key]) {
          _ServiceLocator.Services.store.dispatch(configuratorActions.switchSelectedAmount(oldIdentifiers[key], newIdentifiers[key]));
        }
      }
    }
  }, {
    key: "setConfigurationComment",
    value: function setConfigurationComment(comment) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.setComment(comment));
    }
  }, {
    key: "setSelectedCalculation",
    value: function setSelectedCalculation(identifier, value) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.setSelectedCalculation(identifier, value));
    }
  }, {
    key: "setSelectedVariantIdentifier",
    value: function setSelectedVariantIdentifier(identifier) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.setSelectedVariantIdentifier(identifier));
    }
  }, {
    key: "setOptionInputText",
    value: function setOptionInputText(identifier, value) {
      return _ServiceLocator.Services.store.dispatch(configuratorActions.setOptionInputText(identifier, value));
    }

    /**
     * A simple method for saving the configuration without any additional design data or screenshot
     * @param {string} saveType
     * @param {object} extraData
     * @returns {Promise}
     */
  }, {
    key: "prepareAndSaveConfiguration",
    value: function prepareAndSaveConfiguration(saveType) {
      var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var configuration = this.prepareConfigurationForSave(false, extraData);
      return this.saveConfiguration(configuration, saveType);
    }
  }, {
    key: "addToCartCallback",
    value: function addToCartCallback(configuration) {
      // after saving call parent function if existing or send postMessage (depending on the configuration)
      if (window.parent !== undefined) {
        var addToCartMethod = (0, _configuration2.getConf)('addToCartMethod');
        if (addToCartMethod === 'postMessage' && window.parent.postMessage !== undefined) {
          var appConf = (0, _configuration2.getConf)();
          var targetOrigin = (0, _get["default"])(appConf, 'addToCartPostMessageTargetOrigin', '*');
          window.parent.postMessage({
            method: _createMessageInterface.METHOD_ADD_TO_CART,
            code: configuration.code
          }, targetOrigin);
        } else if (addToCartMethod === 'functionCall' && window.parent.addToCart !== undefined) {
          window.parent.addToCart(configuration.code);
        }
      }
    }
  }]);
  return ConfiguratorService;
}(_AbstractConfiguratorService["default"]);